// Pre-save validation for the tier settings screen. Returns an error message
// string (shown as a toast) or null when everything is valid.
export function validateTierSettings(tiers, tierFinishPrices, finishes, modularMult) {
  if (!tiers.length) return "Add at least one tier";
  const baseCount = tiers.filter((t) => t.is_base).length;
  if (baseCount !== 1) return "Exactly one tier must be marked as the base (Luxury anchor)";
  for (const t of tiers) {
    if (!(t.name || "").trim()) return "Every tier needs a name";
    if (t.modular_multiplier != null && t.modular_multiplier !== "") {
      const mm = parseFloat(t.modular_multiplier);
      if (!Number.isFinite(mm) || mm < 0 || mm > 10) {
        return `${t.name}: modular multiplier must be 0–10`;
      }
    }
  }
  // Per-finish tier prices (blank = fallback to base price).
  for (const t of tiers) {
    if (t.is_base) continue;
    const row = tierFinishPrices[t.id] || {};
    for (const [fid, v] of Object.entries(row)) {
      if (v === "" || v == null) continue;
      const num = parseFloat(v);
      if (!Number.isFinite(num) || num < 0) {
        const fname = finishes.find((f) => f.id === fid)?.name || fid;
        return `${t.name} → ${fname}: price must be ≥ 0`;
      }
    }
  }
  const mm = parseFloat(modularMult);
  if (!Number.isFinite(mm) || mm < 0 || mm > 10) {
    return "Default modular multiplier must be 0–10";
  }
  return null;
}
